'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _RoutingTypes = require('../constants/RoutingTypes');

exports.default = (0, _immutable.Record)({
  '@type': _RoutingTypes.UNASSIGNED
}, 'UnassignedRoutingRules');
module.exports = exports['default'];